<template>
  <DashboardVideo />
  <div class="container d-flex align-items-center justify-content-center z-2">
    <div class="row mobile align-content-between g-0">
      <div
        class="col-12 ps-3 pe-3 d-flex align-items-center justify-content-end theme-header"
      >
        <a
          href="https://test.metaluxe.com.au/"
          target="_blank"
          class="annotation"
          data-bs-toggle="tooltip"
          title="Click to Edits"
        >
          <img src="/img/ui-theme/annotation-red.svg"
        /></a>
        <a href="#" class="m-auto"
          ><img src="/img/ui-theme/logo.png" class="logo"
        /></a>
        <img src="/img/ui-theme/call.png" height="28" />
      </div>
      <div class="col-12 d-flex align-items-center justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <router-link
              v-for="(assetType, index) in assetTypes"
              :key="assetType.Guid"
              :to="{
                name: componentName,
                params: {
                  assetType: assetType.LinkName,
                },
              }"
              type="button"
              :class="[
                'btn-theme-menu',
                'mb-2',
                {
                  'border-bottom-left': index === assetTypes.length - 1,
                  'border-top-right': index === 0,
                },
              ]"
            >
              {{ assetType.ObjectName }}
            </router-link>
          </div>
        </div>
      </div>
      <div
        class="col-12 d-flex align-items-end justify-content-end sticky-bottom theme-footer"
      ></div>
    </div>
  </div>
</template>

<script>
import DashboardVideo from "@/components/DashboardVideo.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";
import sortArray from "sort-array";

export default {
  name: "DashboardHome",
  components: {
    DashboardVideo,
  },
  data() {
    return {
      assetTypes: null,
      componentName: "AssetType",
      componentAdmin: "Admin",
      folderStructure: encodeURIComponent(this.theme.devFolder + "/assets/"),
      brochureUrl: "",
    };
  },
  created() {
    BunnyNetService.getFolders(this.folderStructure)
      .then((response) => {
        // Remap array
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            ComponentName: this.componentName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
          };
        });

        const customMenu = sortArray(menuItems, {
          by: ["LinkName"],
          order: "LinkName",
          customOrders: {
            LinkName: this.theme.menuOrder,
          },
        });

        this.assetTypes = customMenu.filter(
          (assetType) => assetType.LinkName != "type1"
        );
      })
      .catch((error) => {
        console.log(error);
      });
  },
  setup() {
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
